import React from 'react';
import { CheckCircle2, Clock, Calendar, Shield, MessageCircle, List } from 'lucide-react';
export const ProductPresentation: React.FC = () => {
  const benefits = [{
    icon: <Clock className="w-8 h-8 text-green-500" data-id="element-271" />,
    text: 'Ahorrá más de 10 horas por semana en preparación de clases con ejercicios ya organizados por nivel y aparato, listos para implementar inmediatamente'
  }, {
    icon: <Calendar className="w-8 h-8 text-green-500" data-id="element-272" />,
    text: 'Creá un plan anual profesional en menos de 30 minutos usando nuestra plantilla editable en Excel y Google Sheets, y nunca más improvises tus clases'
  }, {
    icon: <Shield className="w-8 h-8 text-green-500" data-id="element-273" />,
    text: 'Ganá confianza en la seguridad de tus clases con el checklist completo que verifica todos los puntos críticos antes, durante y después de cada sesión'
  }, {
    icon: <MessageCircle className="w-8 h-8 text-green-500" data-id="element-274" />,
    text: 'Comunicate como un profesional con los padres usando plantillas de mensajes ya redactadas que generan confianza y reducen malentendidos'
  }, {
    icon: <List className="w-8 h-8 text-green-500" data-id="element-275" />,
    text: 'Accedé instantáneamente a una selección curada de los mejores ejercicios por aparato gimnástico, organizados para que encuentres lo que necesitás en segundos'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-276">
      <div className="max-w-5xl mx-auto px-4" data-id="element-277">
        <div className="text-center mb-16" data-id="element-278">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6" data-id="element-279">
            Y es precisamente por eso que creamos el{' '}
            <br className="hidden md:block" data-id="element-280" />
            <span className="text-blue-600" data-id="element-281">
              Mega-Pack Gimnasia Artística Infanto-Juvenil
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-medium" data-id="element-282">
            Un sistema completo con ejercicios progresivos, plantillas editables
            y guías de comunicación que transformará tu forma de dar clases para
            siempre
          </p>
        </div>

        <div className="grid gap-6" data-id="element-283">
          {benefits.map((benefit, index) => <div key={index} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col md:flex-row items-center md:items-start space-y-4 md:space-y-0 md:space-x-6 hover:shadow-md transition-shadow" data-id="element-284">
              <div className="flex-shrink-0 bg-green-50 p-4 rounded-full" data-id="element-285">
                {benefit.icon}
              </div>
              <p className="text-gray-700 text-lg font-medium leading-relaxed text-center md:text-left" data-id="element-286">
                {benefit.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};